import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IDatePickerDirectiveConfig } from 'ng2-date-picker';

@Component({
    selector: 'app-form-group-datepicker',
    templateUrl: './form-group-datepicker.component.html',
    styleUrls: ['./form-group-datepicker.component.scss'],
    standalone: false
})
export class FormGroupDatepickerComponent implements OnInit {

  datePickerConfig: IDatePickerDirectiveConfig = {
    format: 'DD-MM-YYYY',
    firstDayOfWeek: 'mo'
  };

  @Input()
  label: string;

  @Input()
  model: any;

  @Input()
  disabled = false;

  @Output()
  modelChange: EventEmitter<any> = new EventEmitter<any>();


  constructor() { }

  ngOnInit() {
  }

  change() {
    this.modelChange.emit(this.model);
  }

}
